(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wv-offer-countdown"]) return;
  try {
    
document.querySelectorAll('[data-wv-swiss-countdown]').forEach(banner => {
  const endsAt = Date.parse(banner.dataset.endsAt);
  const update = () => {
    const remaining = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));
    if (!remaining) { banner.hidden = true; return; }
    const units = {days:Math.floor(remaining / 86400),hours:Math.floor(remaining % 86400 / 3600),minutes:Math.floor(remaining % 3600 / 60),seconds:remaining % 60};
    Object.entries(units).forEach(([unit,value]) => { banner.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2,'0'); });
  };
  update();
  const timer = setInterval(update, 1000);
  banner.querySelector('[data-wv-countdown-close]').addEventListener('click', () => { banner.hidden = true; clearInterval(timer); });
});

  } catch(e) { console.error(e); }
})();
})();
